import DataTable from '../../../lib/DataTable/DataTable';
import TooltipWidget from '../../../lib/Tooltip/Tooltip';
import Smartlook from '../../../utils/smartlook';
import {dateFormatter, formatCurrency} from '../../../utils/util';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';
import {
  amountFormatKeys,
  dateFormatKeys,
  scheduleLoanFieldsMapping,
  tableBoldKeys,
} from '../paymentScheduleConstant';

import {
  AccordionDetails,
  AccordionItem,
  AccordionSummary,
  AccordionTitle,
} from '@deere/fuel-react';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './paymentScheduleTableView.css';

const PaymentScheduleTableView = (props) => {
  const [currentAccordion, setCurrentAccordion] = React.useState(0);
  const [rowData, setRowData] = React.useState(null);

  const {t} = useTranslation();

  const createColumns = (keys) => {
    return keys.map((key) => ({
      id: key,
      label: key,
      width: 100 / keys.length + '%',
      ...(props.country === 'pt' && key === 'AMOUNT'
        ? {infoIconText: t('AMOUNT_TOOLTIP')}
        : {}),
    }));
  };

  const valueFormatComponent = (key, data) => {
    let formattedData;
    if (amountFormatKeys.includes(key)) {
      formattedData = formatCurrency(data);
    } else if (dateFormatKeys.includes(key)) {
      formattedData = dateFormatter(data);
    } else {
      formattedData = data;
    }
    if (
      (props.ProductType == 'LEASE-OPERATING' && key == 'NET_RENTAL_OL') ||
      (props.ProductType == 'LEASE-FINANCE-NON-MUN' && key == 'NET_RENTAL')
    ) {
      return (
        <div className="OL_tooltip">
          {formattedData}
          <TooltipWidget
            className={'loanLblTooltip'}
            tooltip={t('OL_INFO_TOOLTIP')}
            placement="right"
          ></TooltipWidget>
        </div>
      );
    }
    return tableBoldKeys.includes(key) ? (
      <div className="paymentScheduleBoldStyle">{formattedData}</div>
    ) : (
      <div>{formattedData}</div>
    );
  };

  const transformArray = () => {
    let rows = [];

    if (props.schedulePayments) {
      for (const scheduled of props.schedulePayments) {
        let tempObj = {};
        if (props.headCells) {
          for (const scheduleItemKey of props.headCells) {
            let value =
              scheduled[scheduleLoanFieldsMapping[scheduleItemKey]] ===
              undefined
                ? '---'
                : scheduled[scheduleLoanFieldsMapping[scheduleItemKey]];
            tempObj[scheduleItemKey] = {
              value: value,
              component:
                value === '---'
                  ? value
                  : valueFormatComponent(scheduleItemKey, value),
            };
          }
        }
        rows.push(tempObj);
      }
    }
    setRowData(rows);
  };

  function handleAccordionClick(index) {
    const newIndex = currentAccordion === index ? undefined : index;
    setCurrentAccordion(newIndex);
  }
  React.useEffect(() => {
    transformArray();
  }, [props.schedulePayments, props.allContractView]);

  React.useEffect(() => {
    Smartlook.navigation('paymentScheduleTableView');
  }, []);

  return rowData ? (
    <AccordionItem
      id="installments-container-index"
      className={
        props.allContractView
          ? 'installments-container'
          : 'installments-container-product'
      }
      key={props.ProductType}
      data-testid={'installments-container-' + props.index}
      expanded={props.index === currentAccordion}
    >
      <AccordionSummary onClick={() => handleAccordionClick(props.index)}>
        <AccordionTitle>{t(props.ProductType)}</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        {rowData && (
          <DataTable
            class="contractOverviewTable"
            headCells={createColumns(props.headCells)}
            rows={rowData}
            defaultColSpan={props.headCells.length}
            rowAlignment={'center'}
            defaultSortKey={'DUE_DATE'}
            defaultSort={'asc'}
            extraAnchor={props.selectedContractNumber}
            showPagination={false}
          />
        )}
      </AccordionDetails>
    </AccordionItem>
  ) : (
    <SkeletonLoader componentName="ContractDetails" />
  );
};
PaymentScheduleTableView.propTypes = {
  schedulePayments: PropTypes.array,
  headCells: PropTypes.array,
  ProductType: PropTypes.string,
  selectedContractNumber: PropTypes.string,
  country: PropTypes.string,
};

export default PaymentScheduleTableView;
